import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import SignIn from './Pages/SignIn/SignIn';
import SignUp from './Pages/SignUp/SignUp';
import Select from './Pages/Select/Select';
import Main from './Pages/Main/Main';
import CartMain from './Components/Cart/CartMain/CartMain';
import CheckoutMain from './Components/CheckoutMain/CheckoutMain';
import DoneMain from './Components/DoneMain/DoneMain';
import Subscriptions from './Pages/Subscriptions/Subscriptions';

const App = () => {
  return ( 
    <Router>
      <div className="app">
        <Switch>
          <Route exact path ="/">
            <SignIn />
          </Route>
          <Route exact path ="/signup">
            <SignUp />
          </Route>
          <Route exact path ="/select">
            <Select />
          </Route>
          <Route exact path ="/main">
            <Main />
          </Route>
          <Route exact path="#cart">
              <CartMain />
          </Route>
          <Route exact path="#checkout">
              <CheckoutMain />
          </Route>
          <Route exact path="#done">
              <DoneMain />
          </Route>
          <Route exact path="/subscriptions">
              <Subscriptions />
          </Route>

        </Switch>
      </div>
    </Router>
   );
}
 
export default App;
   
